module.exports = "{{if count_by_shop}}\n<div class=\"reviews-line-view\">\n\t<a href=\"${shopInfo.reviewlink}\" target=\"_blank\" class=\"review-link\"></a>\n\t<div class=\"reviews-view-col-1\">\n\t\t<span class=\"rev-count\">${count_by_shop} отзывов</span>\n\t\tна магазин\n\t\t<a href=\"reviews/shop/${shopInfo.name_view}/sort_by/date\" target=\"_blank\">${shopName}</a>\n\t</div>\n\t{{if shopInfo.reviewlink}}\n\t<a class=\"rev-readmore\" href=\"${shopInfo.reviewlink}\" target=\"_blank\">Смотреть &raquo;</a>\n\t{{/if}}\n</div>\n{{/if}}\n"


//////////////////
// WEBPACK FOOTER
// ./modules/packages/create_order/templates/reviews-by-shop.html
// module id = XVWq
// module chunks = 2 3 4 5 6 11